/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */
import DataFilterOrderBy from "@/core/js/backend/filters/DataFilterOrderBy.js";
import FilterableItem from "@shared/Filterable/FilterableItem";

export default class SearchKeywordsFilter extends DataFilterOrderBy {

	searchField: string = ""
	searchQuery: string = ""

	shouldTrim: boolean = true
	toLowerCase: boolean = true

	constructor(searchQuery = [], searchField = "searchKeywords", shouldTrim = true, toLowerCase: true) {
		super();
		this.searchField = searchField
		this.searchQuery = searchQuery
		this.shouldTrim = shouldTrim
		this.toLowerCase = toLowerCase
		this.reset(searchQuery)
	}


	reset(searchQuery = []) {
		super.reset();
		this.searchQuery = searchQuery
		let queryTerms = []
		if(Array.isArray(searchQuery)){
			queryTerms = searchQuery
		} else {
			queryTerms = ("" + this.searchQuery).split(" ")
		}
		let trimLength = this.shouldTrim ? FilterableItem.maxKeywordLength : 0
		this.addTextSearchFilterOption(this.searchField, queryTerms, trimLength, this.toLowerCase)
	}


}
